import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  Slide,
  Snackbar,
  TextField,
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  Checkbox,
  Box,
} from "@mui/material";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewProfileAdmin(props) {
  const classes = useStyles();

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [errorAlert, setErrorAlert] = useState("");
  const [openAlertSuccess, setopenAlertSuccess] = useState(false);
  const [mensaje_success, setmensaje_success] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [color, setColor] = React.useState("");
  const [selectedModules, setSelectedModules] = React.useState([]);
  const [stateCheckbox, setCheckboxState] = React.useState({
    usersClientAdmin: false,
    profilesClientAdmin: false,
    headerFooterClientAdmin: false,
    homepageClientAdmin: false,
    roomsClientAdmin: false,
    configClientAdmin: false,
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    name: "",
    errorName: false,
  });

  const handleChange = (prop) => (event) => {
    setopenAlertSuccess(false);

    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
    });
    setOpenAlert(false);
  };

  const handleModuleSelection = (event) => {
    const { name, checked } = event.target;

    // 1. Actualizar estado visual de los checkboxes
    setCheckboxState((prev) => ({
      ...prev,
      [name]: checked,
    }));

    // 2. Actualizar array de módulos seleccionados
    setSelectedModules((prev) => {
      const moduleIdMap = {
        usersClientAdmin: 21,
        profilesClientAdmin: 22,
        headerFooterClientAdmin: 23,
        homepageClientAdmin: 24,
        roomsClientAdmin: 25,
        configClientAdmin: 26,
        // añadir más módulos según necesidad
      };

      if (checked) {
        // Si está marcado, añadir al array si no existe
        return prev.some((module) => module.name === name)
          ? prev
          : [...prev, { name, id: moduleIdMap[name] }];
      } else {
        // Si está desmarcado, filtrar para remover
        return prev.filter((module) => module.name !== name);
      }
    });
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setError("");
    setopenAlertSuccess(false);

    if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setMensaje('El campo "Nombre" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else if (color === "") {
      setMensaje('El campo "Color perfil" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else {
      const dataValue = {
        name: values.name,
        color: color,
        account: UserAuth.profile_id === 1 ? "admin" : "client",
        userCreated: UserAuth.id,
        clientsId: UserAuth.clients_id,
      };

      try {
        const response = await axios.post(`${urlServices}profile`, dataValue, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        });

        await saveModuleProfile(response.data.profile.id);

        setopenAlertSuccess(true);
        setmensaje_success(response.data.message);
        props.callBackRefresh();

        setValues({ ...values, name: "" });

        setColor("");
        setSelectedModules([]);
        setCheckboxState({
          usersClientAdmin: false,
          profilesClientAdmin: false,
        });
      } catch (err) {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      }
    }
  };

  const saveModuleProfile = async (profileId) => {
    try {
      // Módulos fijos que quieres insertar al inicio
      const defaultModules = [
        { profileId: profileId, resourceId: 11 },
        { profileId: profileId, resourceId: 18 },
      ];

      // Combinar los módulos fijos con los seleccionados
      const allModules = [
        ...defaultModules,
        ...selectedModules.map((module) => ({
          profileId: profileId,
          resourceId: module.id,
        })),
      ];

      // Crear las peticiones
      const requests = allModules.map((data) =>
        axios.post(`${urlServices}profiles-resources`, data, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
      );

      // Esperar que todas se completen
      await Promise.all(requests);
    } catch (err) {
      console.error("Error al guardar los módulos del perfil:", err);
      throw err;
    }
  };

  const handleChangeColor = (event) => {
    setColor(event.target.value);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
        //style={{ zIndex: 100 }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error && <Alert severity="error">{mensageSystem}</Alert>}
                <div className={classes.titleCardFilter}>Nuevo rol</div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl style={{ width: "100%", marginTop: 15 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Nombre
                  </b>
                  <TextField
                    name="name"
                    value={values.name}
                    error={values.errorName}
                    onChange={handleChange("name")}
                    fullWidth
                    required
                    inputProps={{
                      /* style: {
                        textAlign: "center",
                      },*/
                      maxLength: 25,
                    }}
                    //  label="Nombre"
                    margin="dense"
                    variant="outlined"
                    autoComplete="off"
                    size="small"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mt: 2, ml: 2 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Color del rol
                  </b>
                  <FormControl sx={{ width: "100%", ml: 2, mt: 1 }}>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={color}
                      onChange={handleChangeColor}
                      row
                    >
                      <FormControlLabel
                        value="#f7cac9"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#f7cac9", width: 42, height: 40 }}
                      />
                      <FormControlLabel
                        value="#FFE5B4"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#FFE5B4", width: 42, height: 40 }}
                      />
                      <FormControlLabel
                        value="#cce5ff"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#cce5ff", width: 42, height: 40 }}
                      />
                      <FormControlLabel
                        value="#E6E6FA"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#E6E6FA", width: 42, height: 40 }}
                      />
                      <FormControlLabel
                        value="#c7f6d4"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#c7f6d4", width: 42, height: 40 }}
                      />
                      <FormControlLabel
                        value="#fffec2"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#fffec2", width: 42, height: 40 }}
                      />
                      <FormControlLabel
                        value="#eeeeef"
                        control={
                          <Radio size="small" style={{ color: "#000" }} />
                        }
                        style={{ background: "#eeeeef", width: 42, height: 40 }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 16, color: "#000" }}
                >
                  Activar módulos al perfil
                </b>
                <Alert severity="info" sx={{ mb: 3 }}>
                  Seleccione los módulos que están permitidos para este rol.
                </Alert>
                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 14, fontWeight: 500 }}
                >
                  Usuarios:
                </b>
                <FormControl sx={{ width: "100%", ml: 2, mt: 1, mb: 1 }}>
                  <FormGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={color}
                    // onChange={handleChangeColor}
                    row
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={4}>
                        <FormControlLabel
                          label="Administrar usuarios"
                          value="#f7cac9"
                          control={
                            <Checkbox
                              style={{ color: "#000" }}
                              checked={stateCheckbox.usersClientAdmin}
                              onChange={handleModuleSelection}
                              name="usersClientAdmin"
                            />
                          }
                          sx={{
                            background: "#f6f6f6",
                            border: "1px solid #ccc",
                            borderRadius: 3,
                            width: "100%",
                            height: 50,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <FormControlLabel
                          label="Roles"
                          value="#f7cac9"
                          control={
                            <Checkbox
                              style={{ color: "#000" }}
                              checked={stateCheckbox.profilesClientAdmin}
                              onChange={handleModuleSelection}
                              name="profilesClientAdmin"
                            />
                          }
                          sx={{
                            background: "#f6f6f6",
                            border: "1px solid #ccc",
                            borderRadius: 3,
                            width: "100%",
                            height: 50,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>

                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 14, fontWeight: 500 }}
                >
                  Manejar sitio web:
                </b>
                <FormControl sx={{ width: "100%", ml: 2, mt: 1, mb: 1 }}>
                  <FormGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={color}
                    // onChange={handleChangeColor}
                    row
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={4}>
                        <FormControlLabel
                          label="Encabezado y Footer"
                          value="#f7cac9"
                          control={
                            <Checkbox
                              style={{ color: "#000" }}
                              checked={stateCheckbox.headerFooterClientAdmin}
                              onChange={handleModuleSelection}
                              name="headerFooterClientAdmin"
                            />
                          }
                          sx={{
                            background: "#f6f6f6",
                            border: "1px solid #ccc",
                            borderRadius: 3,
                            width: "100%",
                            height: 50,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <FormControlLabel
                          label="Página de inicio"
                          value="#f7cac9"
                          control={
                            <Checkbox
                              style={{ color: "#000" }}
                              checked={stateCheckbox.homepageClientAdmin}
                              onChange={handleModuleSelection}
                              name="homepageClientAdmin"
                            />
                          }
                          sx={{
                            background: "#f6f6f6",
                            border: "1px solid #ccc",
                            borderRadius: 3,
                            width: "100%",
                            height: 50,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>

                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 14, fontWeight: 500 }}
                >
                  Habitaciones:
                </b>
                <FormControl sx={{ width: "100%", ml: 2, mt: 1, mb: 1 }}>
                  <FormGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={color}
                    // onChange={handleChangeColor}
                    row
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={4}>
                        <FormControlLabel
                          label="Habitaciones"
                          value="#f7cac9"
                          control={
                            <Checkbox
                              style={{ color: "#000" }}
                              checked={stateCheckbox.roomsClientAdmin}
                              onChange={handleModuleSelection}
                              name="roomsClientAdmin"
                            />
                          }
                          sx={{
                            background: "#f6f6f6",
                            border: "1px solid #ccc",
                            borderRadius: 3,
                            width: "100%",
                            height: 50,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>

                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 14, fontWeight: 500 }}
                >
                  Configuración:
                </b>
                <FormControl sx={{ width: "100%", ml: 2, mt: 1, mb: 1 }}>
                  <FormGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={color}
                    // onChange={handleChangeColor}
                    row
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={4}>
                        <FormControlLabel
                          label="Configuración"
                          value="#f7cac9"
                          control={
                            <Checkbox
                              style={{ color: "#000" }}
                              checked={stateCheckbox.configClientAdmin}
                              onChange={handleModuleSelection}
                              name="configClientAdmin"
                            />
                          }
                          sx={{
                            background: "#f6f6f6",
                            border: "1px solid #ccc",
                            borderRadius: 3,
                            width: "100%",
                            height: 50,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <br></br>
                <center>
                  <ButtonStyle0 type="submit" onClick={submitForm}>
                    Guardar
                  </ButtonStyle0>
                </center>
              </Grid>
              <Grid item xs={12} sm={12}>
                <center>
                  {openAlertSuccess && (
                    <Alert severity="success">{mensaje_success}</Alert>
                  )}
                </center>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={errorAlert === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
